
;(function seibertronMotorcycleConfirmedGalleryRestore20260714() {
  var scriptFile = 'motorcycle-confirmed-gallery-restore-20260714.js';
  var products = {
    "gloves-for-motorcycle": {
        "defaultValue": "Pink",
        "chartFile": "sps2-plus-size-chart-vertical-20260714.svg",
        "chartWidth": 1000,
        "chartHeight": 1320,
        "chartAlt": "Seibertron SPS-2 Plus motorcycle gloves adult and youth size chart",
        "aliases": {
            "grey": "Gray",
            "gray": "Gray",
            "fluorescent": "Yellow",
            "fluorescent yellow": "Yellow"
        },
        "entries": [
            {
                "id": "33435862171838",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-white-white-bg-main-20260714.jpg?v=1783960390",
                "alt": "color:White | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375794462910",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-07.jpg?v=1783410268",
                "alt": "color:White | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 07"
            },
            {
                "id": "33375794495678",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-08.jpg?v=1783410269",
                "alt": "color:White | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 08"
            },
            {
                "id": "33375794528446",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-09.jpg?v=1783410269",
                "alt": "color:White | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 09"
            },
            {
                "id": "33375794561214",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-10.jpg?v=1783410269",
                "alt": "color:White | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 10"
            },
            {
                "id": "33375795839166",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-49.jpg?v=1783410269",
                "alt": "color:all | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 49"
            },
            {
                "id": "33435862466750",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-gray-white-bg-main-20260714.jpg?v=1783960398",
                "alt": "color:Gray | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375794856126",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-19.jpg?v=1783410269",
                "alt": "color:Gray | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 19"
            },
            {
                "id": "33375794888894",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-20.jpg?v=1783410268",
                "alt": "color:Gray | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 20"
            },
            {
                "id": "33375794921662",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-21.jpg?v=1783410268",
                "alt": "color:Gray | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 21"
            },
            {
                "id": "33375794954430",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-22.jpg?v=1783410269",
                "alt": "color:Gray | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 22"
            },
            {
                "id": "33435862925502",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-red-white-bg-main-20260714.jpg?v=1783960404",
                "alt": "color:Red | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375795052734",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-25.jpg?v=1783410269",
                "alt": "color:Red | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 25"
            },
            {
                "id": "33375795085502",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-26.jpg?v=1783410268",
                "alt": "color:Red | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 26"
            },
            {
                "id": "33375795118270",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-27.jpg?v=1783410268",
                "alt": "color:Red | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 27"
            },
            {
                "id": "33375795151038",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-28.jpg?v=1783410268",
                "alt": "color:Red | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 28"
            },
            {
                "id": "33435863351486",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-black-white-bg-main-20260714.jpg?v=1783960410",
                "alt": "color:Black | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375794266302",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-01.jpg?v=1783410269",
                "alt": "color:Black | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 01"
            },
            {
                "id": "33375794299070",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-02.jpg?v=1783410268",
                "alt": "color:Black | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 02"
            },
            {
                "id": "33375794331838",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-03.jpg?v=1783410268",
                "alt": "color:Black | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 03"
            },
            {
                "id": "33375794364606",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-04.jpg?v=1783410269",
                "alt": "color:Black | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 04"
            },
            {
                "id": "33403638579390",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/5.jpg?v=1783672364",
                "alt": "color:Pink | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375795249342",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-31.jpg?v=1783410269",
                "alt": "color:Pink | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 31"
            },
            {
                "id": "33375795282110",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-32.jpg?v=1783410268",
                "alt": "color:Pink | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 32"
            },
            {
                "id": "33375795314878",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-33.jpg?v=1783410268",
                "alt": "color:Pink | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 33"
            },
            {
                "id": "33375795347646",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-34.jpg?v=1783410269",
                "alt": "color:Pink | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 34"
            },
            {
                "id": "33435863711934",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-orange-white-bg-main-20260714.jpg?v=1783960417",
                "alt": "color:Orange | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375794659518",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-13.jpg?v=1783410269",
                "alt": "color:Orange | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 13"
            },
            {
                "id": "33375794692286",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-14.jpg?v=1783410269",
                "alt": "color:Orange | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 14"
            },
            {
                "id": "33375794725054",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-15.jpg?v=1783410269",
                "alt": "color:Orange | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 15"
            },
            {
                "id": "33375794757822",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-16.jpg?v=1783410269",
                "alt": "color:Orange | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 16"
            },
            {
                "id": "33435864301758",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-brown-white-bg-main-20260714.jpg?v=1783960425",
                "alt": "color:Brown | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375795445950",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-37.jpg?v=1783410268",
                "alt": "color:Brown | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 37"
            },
            {
                "id": "33375795478718",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-38.jpg?v=1783410268",
                "alt": "color:Brown | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 38"
            },
            {
                "id": "33375795511486",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-39.jpg?v=1783410269",
                "alt": "color:Brown | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 39"
            },
            {
                "id": "33375795544254",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-40.jpg?v=1783410269",
                "alt": "color:Brown | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 40"
            },
            {
                "id": "33435864826046",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps2-plus-yellow-white-bg-main-20260714.jpg?v=1783960432",
                "alt": "color:Yellow | Seibertron SPS-2 Plus motorcycle gloves white background main image"
            },
            {
                "id": "33375795642558",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-43.jpg?v=1783410268",
                "alt": "color:Yellow | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 43"
            },
            {
                "id": "33375795675326",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-44.jpg?v=1783410269",
                "alt": "color:Yellow | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 44"
            },
            {
                "id": "33375795708094",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-45.jpg?v=1783410269",
                "alt": "color:Yellow | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 45"
            },
            {
                "id": "33375795740862",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps2-plus-gloves-for-motorcycle-gallery-46.jpg?v=1783410269",
                "alt": "color:Yellow | Seibertron SPS2 Plus summer motorcycle gloves with carbon fiber knuckle protection image 46"
            }
        ],
        "groups": {
            "White": [
                "33435862171838",
                "33375794462910",
                "33375794495678",
                "33375794528446",
                "33375794561214",
                "33375795839166"
            ],
            "Gray": [
                "33435862466750",
                "33375794856126",
                "33375794888894",
                "33375794921662",
                "33375794954430",
                "33375795839166"
            ],
            "Red": [
                "33435862925502",
                "33375795052734",
                "33375795085502",
                "33375795118270",
                "33375795151038",
                "33375795839166"
            ],
            "Black": [
                "33435863351486",
                "33375794266302",
                "33375794299070",
                "33375794331838",
                "33375794364606",
                "33375795839166"
            ],
            "Pink": [
                "33403638579390",
                "33375795249342",
                "33375795282110",
                "33375795314878",
                "33375795347646",
                "33375795839166"
            ],
            "Orange": [
                "33435863711934",
                "33375794659518",
                "33375794692286",
                "33375794725054",
                "33375794757822",
                "33375795839166"
            ],
            "Brown": [
                "33435864301758",
                "33375795445950",
                "33375795478718",
                "33375795511486",
                "33375795544254",
                "33375795839166"
            ],
            "Yellow": [
                "33435864826046",
                "33375795642558",
                "33375795675326",
                "33375795708094",
                "33375795740862",
                "33375795839166"
            ]
        }
    },
    "seibertron-sps-6-mens-leather-racing-gloves-all-season-bike-hand-gloves-with-carbon-fiber-protection-for-road-racing-track-riding-and-touring-motorcycle-use": {
        "defaultValue": "Yellow",
        "chartFile": "sps6-motorcycle-gloves-size-chart-vertical-20260714.png",
        "chartWidth": 1800,
        "chartHeight": 2471,
        "chartAlt": "Seibertron SPS-6 motorcycle gloves adult and youth size chart",
        "aliases": {
            "fluorescent yellow": "Yellow",
            "fluorescent": "Yellow",
            "fl": "Yellow"
        },
        "entries": [
            {
                "id": "33435870036158",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps6-yellow-white-bg-main-20260714.jpg?v=1783960452",
                "alt": "color:Yellow | Seibertron SPS-6 motorcycle gloves white background main image"
            },
            {
                "id": "33374611013822",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-01.jpg?v=1783398253",
                "alt": "color:Yellow | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 01"
            },
            {
                "id": "33374611046590",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-02.jpg?v=1783398253",
                "alt": "color:Yellow | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 02"
            },
            {
                "id": "33374611079358",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-03.jpg?v=1783398253",
                "alt": "color:Yellow | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 03"
            },
            {
                "id": "33374611112126",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-04.jpg?v=1783398253",
                "alt": "color:Yellow | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 04"
            },
            {
                "id": "33374611144894",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-05.jpg?v=1783398253",
                "alt": "color:Yellow | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 05"
            },
            {
                "id": "33435870855358",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps6-black-white-bg-main-20260714.jpg?v=1783960459",
                "alt": "color:Black | Seibertron SPS-6 motorcycle gloves white background main image"
            },
            {
                "id": "33374611177662",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-06.jpg?v=1783398253",
                "alt": "color:Black | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 06"
            },
            {
                "id": "33374611210430",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-07.jpg?v=1783398253",
                "alt": "color:Black | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 07"
            },
            {
                "id": "33374611243198",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-08.jpg?v=1783398253",
                "alt": "color:Black | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 08"
            },
            {
                "id": "33374611275966",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-09.jpg?v=1783398253",
                "alt": "color:Black | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 09"
            },
            {
                "id": "33374611308734",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-10.jpg?v=1783398253",
                "alt": "color:Black | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 10"
            },
            {
                "id": "33435871346878",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps6-white-white-bg-main-20260714.jpg?v=1783960467",
                "alt": "color:White | Seibertron SPS-6 motorcycle gloves white background main image"
            },
            {
                "id": "33374611341502",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-11.jpg?v=1783398253",
                "alt": "color:White | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 11"
            },
            {
                "id": "33374611374270",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-12.jpg?v=1783398254",
                "alt": "color:White | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 12"
            },
            {
                "id": "33374611407038",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-13.jpg?v=1783398253",
                "alt": "color:White | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 13"
            },
            {
                "id": "33374611439806",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-14.jpg?v=1783398254",
                "alt": "color:White | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 14"
            },
            {
                "id": "33374611472574",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-15.jpg?v=1783398253",
                "alt": "color:White | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 15"
            },
            {
                "id": "33435871477950",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-sps6-red-white-bg-main-20260714.jpg?v=1783960474",
                "alt": "color:Red | Seibertron SPS-6 motorcycle gloves white background main image"
            },
            {
                "id": "33374611505342",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-16.jpg?v=1783398253",
                "alt": "color:Red | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 16"
            },
            {
                "id": "33374611538110",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-17.jpg?v=1783398253",
                "alt": "color:Red | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 17"
            },
            {
                "id": "33374611570878",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-18.jpg?v=1783398253",
                "alt": "color:Red | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 18"
            },
            {
                "id": "33374611603646",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-19.jpg?v=1783398253",
                "alt": "color:Red | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 19"
            },
            {
                "id": "33374611636414",
                "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/sps6-leather-racing-gallery-20.jpg?v=1783398253",
                "alt": "color:Red | Seibertron SPS-6 leather racing gloves with carbon fiber protection image 20"
            }
        ],
        "groups": {
            "Yellow": [
                "33435870036158",
                "33374611013822",
                "33374611046590",
                "33374611079358",
                "33374611112126",
                "33374611144894"
            ],
            "Black": [
                "33435870855358",
                "33374611177662",
                "33374611210430",
                "33374611243198",
                "33374611275966",
                "33374611308734"
            ],
            "White": [
                "33435871346878",
                "33374611341502",
                "33374611374270",
                "33374611407038",
                "33374611439806",
                "33374611472574"
            ],
            "Red": [
                "33435871477950",
                "33374611505342",
                "33374611538110",
                "33374611570878",
                "33374611603646",
                "33374611636414"
            ]
        }
    }
};
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf(scriptFile) !== -1; });
    if (own) return own.src.replace(scriptFile, file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function ensureStyle() {
    var style = document.getElementById('motorcycle-confirmed-gallery-restore-style-20260714') || document.createElement('style');
    style.id = 'motorcycle-confirmed-gallery-restore-style-20260714';
    var scopes = Object.keys(products).map(function (handle) { return '.auto-product[data-product-handle="' + handle + '"]'; });
    function scoped(suffix) { return scopes.map(function (scope) { return scope + suffix; }).join(','); }
    style.textContent = scoped(' [data-auto-visual-option-value] [data-auto-choice-label]') + '{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff;position:relative;cursor:pointer}' +
      scoped(' .auto-product__swatch-image') + '{display:block;width:100%;height:100%;pointer-events:none}' +
      scoped(' .auto-product__swatch-image img') + '{display:block;width:100%;height:100%;object-fit:contain;background:#fff;pointer-events:none}' +
      scoped(' .auto-product__swatch-label') + '{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;pointer-events:none}';
    if (!style.parentNode) document.head.appendChild(style);
  }
  function normalize(config, value) {
    var text = String(value || '').trim();
    var key = text.toLowerCase();
    return config.aliases[key] || config.groups[text] && text || config.groups[config.aliases[key]] && config.aliases[key] || text || config.defaultValue;
  }
  function selectedValue(root, config) {
    var checkedInSwatch = root.querySelector('[data-auto-visual-option-value] input:checked');
    if (checkedInSwatch) {
      var holder = checkedInSwatch.closest('[data-auto-visual-option-value]');
      if (holder) return normalize(config, holder.getAttribute('data-auto-visual-option-value'));
    }
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked, input[name="options[style]"]:checked, input[name="options[Style]"]:checked');
    return normalize(config, checked ? checked.value : config.defaultValue);
  }
  function entryMap(config) {
    if (config.entryById) return config.entryById;
    config.entryById = {};
    config.entries.forEach(function (entry) { config.entryById[entry.id] = entry; });
    return config.entryById;
  }
  function groupFor(config, value) {
    var entries = entryMap(config);
    var key = normalize(config, value);
    return (config.groups[key] || config.groups[config.defaultValue] || []).map(function (id) { return entries[id]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, config, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(config, value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryMap(config)[preferredId] && visibleIds[preferredId] ? entryMap(config)[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root, config) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = normalize(config, label.getAttribute('data-auto-visual-option-value') || '');
      var entry = groupFor(config, value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="78" height="78" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function replaceChart(root, config) {
    root.querySelectorAll('img.auto-product__guide-image').forEach(function (img) {
      img.src = scriptUrl(config.chartFile);
      img.srcset = '';
      img.width = config.chartWidth;
      img.height = config.chartHeight;
      img.alt = config.chartAlt;
    });
  }
  function runOne(handle, config) {
    var root = document.querySelector('.auto-product[data-product-handle="' + handle + '"]');
    if (!root) return;
    ensureStyle();
    replaceChart(root, config);
    hydrateSwatches(root, config);
    showGroup(root, config, selectedValue(root, config));
    var flag = 'motorcycleConfirmedGalleryRestoreBound';
    if (!root.dataset[flag]) {
      root.dataset[flag] = 'true';
      root.addEventListener('click', function (event) {
        var swatch = event.target && event.target.closest ? event.target.closest('[data-auto-visual-option-value]') : null;
        if (!swatch || !root.contains(swatch)) return;
        if (swatch.classList && swatch.classList.contains('is-unavailable')) return;
        var clickedValue = swatch.getAttribute('data-auto-visual-option-value') || config.defaultValue;
        var input = swatch.querySelector('input[type="radio"]');
        if (input && !input.disabled && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        [0, 80, 350, 900, 1600].forEach(function (delay) {
          window.setTimeout(function () {
            replaceChart(root, config);
            hydrateSwatches(root, config);
            showGroup(root, config, clickedValue);
          }, delay);
        });
      });
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          [0, 350, 900, 1600].forEach(function (delay) {
            window.setTimeout(function () {
              replaceChart(root, config);
              hydrateSwatches(root, config);
              showGroup(root, config, selectedValue(root, config));
            }, delay);
          });
        }
      });
    }
  }
  function run() {
    Object.keys(products).forEach(function (handle) { runOne(handle, products[handle]); });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [80, 250, 600, 1000, 1500, 2200, 3200, 5000, 7500, 10000].forEach(function (delay) { window.setTimeout(run, delay); });
})();
